<template>
  <div>
    <SearchAutocomplete
        :items="countriesinput"
        :label="labelCountry"
        ref="predpolCountryAutocomlete"
        @onSetResult="(event)=>{onSetCountry(event)}"
        @onClearResult="$emit('update:country', ''); $emit('update:city', ''); $emit('update:region',''); $emit('update:poselok','')"
        v-model="countryValue"
        :objectKey="countryKey"
        :isDataUpdating="isDataUpdating"
        :isSubmitted="isSubmitted"
        :isDisabled="countriesinput.length <= 1"
    ></SearchAutocomplete>

			<div class="checkbox__wrapper">
          <input
                  type="checkbox"
                  :checked="isSelo"
                  :value="isSelo"
                  :disabled="this.country && this.country.length === 0"
                  @change="handleSelo($event.target.checked);"
                  :id="isSeloLabelId"
          />
          <label :for="isSeloLabelId">Поставьте галочку, если организация находится в поселке. селе, деревне</label>
			</div>


    <div class="columns">
      <div class="column">
        <template v-if="!isSelo">
          <SearchAutocompleteCities
              :items="citiestoinput"
              ref="predpolCityAutocomlete"
              v-model="cityValue"
              @onSetResult="(event)=>{$emit('update:city', event); setRegion}"
              @onClearResult="this.cityValue = ''; this.regionValue = ''"
              :label="labelCity"
              :objectKey="cityKey"
              :isDataUpdating="isDataUpdating"
              :description="cityDescription"
              :isSubmitted="isSubmitted"
          >
          </SearchAutocompleteCities>
<!--          <SearchAutocompleteCities-->
<!--              v-else-->
<!--              :label="labelCity"-->
<!--              :modelValue="''"-->
<!--          >-->
<!--          </SearchAutocompleteCities>-->

        </template>
        <template v-else>
          <BaseInput
              :label="labelSelo"
              objectKey="poselok"
              @onChange="(val)=>{$emit('update:poselok', val); this.saveData()}"
              v-model="poselokValue"
              :isDataUpdated="isDataUpdating"
          ></BaseInput>
        </template>
      </div>
      <div class="column">
        <div class="field" @click="regionClick">
          <template v-if="isSelo && country === 'Российская Федерация'">
            <SearchAutocompleteRegions
                :items="regionstoinput"
                ref="predpolRegionAutocomlete"
                @onSetResult="(event)=>{$emit('update:region', event);}"
                :label="labelRegion"
                :objectKey="regionKey"
                v-model="regionValue"
                @onBlur="regionBlur"
                @click="handleRegionClick"
                :isDataUpdating="isDataUpdating"
                :isSubmitted="isSubmitted"
            ></SearchAutocompleteRegions>
          </template>
          <template v-else>
            <label class="req required">{{ labelRegion }}</label>
            <input
                :class="isSubmitted && region.length===0 ? 'has_errors':''"
                :disabled="isDataUpdating"
                :readonly="!isSelo || country !== 'Российская Федерация'"
                @change="saveData"
                @click="handleRegionClick"
                type="text"
                :value="region"
            >
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchAutocomplete from "./../Base/SearchAutocomplete2";
import BaseInput from "./../Base/BaseInput3";
import axios from "axios";
import SearchAutocompleteCities from "./../Base/SearchAutocompleteCities2";
import SearchAutocompleteRegions from "./../Base/SearchAutocompleteRegions";

export default {
  name: "BaseLocation.vue",
  props: {
    // Ключи, в родительском объекте для сохранения.
    countryKey: {},
    cityKey: {},
    regionKey: {},
    // Не обязательный параметр. Если хранится не в корне родительского объекта.
    parentObj: {},
    // Список стран для отображения.
    countriesinput: [],
    labelCountry: {},
    labelCity: {},
    labelRegion: {},
    labelSelo: {},
    isDataUpdating: {},
    isSubmitted: {},
    defaultCountry: {},
    country: {},
    isSeloLabelId: {},
    isSelo: {},
    city: {},
    region: {},
    poselok: {}
  },
  data() {
    return {
      //Список городов для отображения
      citiestoinput: '',
      regionstoinput: [],
      regionReadOnly: true,
      countryValue: '',
      cityValue: '',
      poselokValue: '',
      regionValue: ''
    };
  },
  components: {
    SearchAutocomplete,
    SearchAutocompleteCities,
    SearchAutocompleteRegions,
    BaseInput
  },
  computed: {
    cityDescription() {
      if (this.country !== '' && this.country !== 'Российская Федерация' && this.country !== 'Казахстан' && this.country !== 'Беларусь' && this.country !== 'Украина') {
        return 'Название указывается латинскими буквами';
      }
      return '';
    }
  },
  mounted() {
    this.countryValue = this.country;
    this.cityValue = this.city;
    this.poselokValue = this.poselok;
    this.regionValue = this.region;

    this.loadCities();
    this.loadRegions();
  },
  methods: {
    saveData() {
      if (this.parentObj !== undefined) {
        this.$parent[this.parentObj][this.countryKey] = this.countryValue;
        this.$parent[this.parentObj][this.cityKey] = this.cityValue;
        this.$parent[this.parentObj][this.regionKey] = this.regionValue;
        // if (this.$parent.area.isSelo) {
        //   this.$parent[this.parentObj].selo = this.selo;
        // }
      } else {
        this.$parent[this.countryKey] = this.countryValue;
        this.$parent[this.cityKey] = this.cityValue;
        this.$parent[this.regionKey] = this.regionValue;
      }
      this.$parent.saveData();
    },
    loadCities() {
      const self = this;

      const current_country = self.countriesinput.filter(function (el) {
        return el["ru_name"] === self.countryValue;
      })


      if (current_country[0] && current_country[0].number) {
        axios.get('/get_world_cities/' + current_country[0].number, {
          headers: {
            'Accept': 'application/json',
          }
        }).then((response) => {

          self.citiestoinput = response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    },
    async loadRegions(country = '') {
      const self = this;
      if (country.length === 0) {
        country = self.country;
      }

      const current_country = self.countriesinput.filter(function (el) {
        return el["ru_name"] === country;
      });

      if (current_country[0] && current_country[0].number) {
        await axios.get('/get_all_regions/' + current_country[0].number, {
          headers: {
            'Accept': 'application/json',
          }
        }).then((response) => {
          self.regionstoinput = response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    },
    isFieldRequired(key) {
      if (key) {
        return this.$parent.isFieldRequired(key);
      }
      return false;
    },
    onSetCountry(event) {
      this.$emit('update:country', event);
      if (event !== 'Российская Федерация') {
        this.$emit('update:region', "-");
        this.regionValue = "-";
      } else {
        this.loadRegions(event);
      }
    },
    setRegion() {
      if (!this.isSelo) {
        if (this.countryValue === 'Российская Федерация') {
          const findItem = this.citiestoinput.find(el => el.ru_name === this.cityValue);
          if (findItem) {
            this.$emit('update:region', findItem.region);
            this.regionValue = findItem.region;
          }
        } else {
          this.$emit('update:region', '-');
          this.regionValue = '-';
        }
      }
    },
    regionBlur() {
      this.regionValue = '';
    },
    handleRegionClick() {
      if (this.country.length === 0) {
        alert('Выберите страну');
        return;
      }
      if (this.country !== 'Российская Федерация') {
        alert('Это поле заполняется автоматически');
        return;
      }
      if (!this.isSelo) {
        if (this.cityValue.length === 0) {
          alert('Выберите город');
          return;
        }
        alert('Это поле заполняется автоматически')
      }
    },
    handleSelo(val) {
      this.$emit('update:isSelo', val);
      if (val) {
        this.regionValue = '';
      }

      const index = this.$parent.validationRules.findIndex(object => {
        return object.fieldName === 'city';
      });
      const indexSelo = this.$parent.validationRules.findIndex(object => {
        return object.fieldName === 'poselok';
      });

      if (this.$parent[this.parentObj]?.isSelo !== undefined && this.$parent[this.parentObj].isSelo) {
        this.$parent.validationRules[index].isRequired = false;
        if (this.$parent.validationRules[indexSelo]) {
          this.$parent.validationRules[indexSelo].isRequired = true;
        }

      } else {
        this.$parent.validationRules[index].isRequired = true;
        if (this.$parent.validationRules[indexSelo]) {
          this.$parent.validationRules[indexSelo].isRequired = false;
        }
      }
      this.loadRegions();

      this.saveData();
    }
  },
  watch: {
    city(val) {
      this.cityValue = val;
    },
    poselok(val) {
      this.poselokValue = val;
    },
    region(val) {
      this.regionValue = val;
    },
    country(val) {
      if (val === 'RU') {
        val = 'Российская Федерация';
      }
      this.countryValue = val;
      this.loadCities();
    }
  }
}
</script>

<style scoped>
.input_wrapper {
  position: relative;
}

.field input[type="text"] {
  padding-left: 20px;
}

/*.clearIcon {*/
/*  position: absolute;*/
/*  left: 10px;*/
/*  top: 15px;*/
/*  cursor: pointer;*/
/*}*/

/*input[type="checkbox"] + *::before {*/
/*  display: none;*/
/*}*/
/*input[type="checkbox"] {*/
/*  display: inline-block;*/
/*}*/
</style>
